export class MoleculePanelServiceInfoMachineComponent {
    public template = require('./panel-service-info-machine.html');
}
